export const USER_ROLES = {
  USER_MAP_VIEWER: 'usermapviewer',
  SUPERVISOR: 'supervisor'
}
